export default __webpack_public_path__ + "static/media/movetotrash.0324e278.jpg";